const CardModel = require('../../../../shared/sharedModels').EvidenceCard;

const Constants = {
   SetCurrentEvidenceCard: 'SetCurrentEvidenceCard',
   SetCurrentCardField: 'E_SetCurrentCardField',
   SetRecentCards: 'SetRecentCards',
   SetCardList: 'E_SetCardList',
   SetCurrentVote: 'SetCurrentVote',
   AddCardToList: 'er_AddCardToList',
   SetUnapproved: 'er_SetUnapproved',
   AddCardToUnapprovedList: 'er_AddCardToUnapprovedList',
   SetRevisingCard: 'er_SetRevisingCard'
};

exports.EvidenceCardReducer = (state={},action) =>{
   switch(action.type){
      case Constants.SetCurrentEvidenceCard:
         return {...state, curCard: new CardModel(action.evidenceCard)};
      case Constants.SetCurrentCardField: {
         const curCard = state.curCard;
         const newCard = Object.assign({}, curCard, {[action.field]: action.value});
         return Object.assign({}, state, {curCard: new CardModel(newCard)});
      }
      case Constants.SetRecentCards:
         return {...state, recentCards: action.recentCards};
      case Constants.SetCardList:
         return {...state, cardList: action.cardList};
      case Constants.SetUnapproved:
         return {...state, unapprovedList: action.unapprovedList};
      case Constants.SetCurrentVote:
         let newVoteEvidenceCardObject = {...state.curCard, idVoteType: action.value};
         return {...state, curCard: new CardModel(newVoteEvidenceCardObject)};
      case Constants.AddCardToList:{
         let cardList = state.cardList.slice();
         cardList.push(action.card);
         return {...state, cardList}
      }
      case Constants.AddCardToUnapprovedList:{
         let unapprovedList = state.unapprovedList.slice();
         unapprovedList.unshift(action.card);
         return {...state, unapprovedList}
      }
      case Constants.SetRevisingCard:
         return {...state, revisingCard: action.revisingCard};
      default:
         return state;
   }
};

const FunctionList = {};

FunctionList.setCurrentCard = (evidenceCard) => {
   return{
      type: Constants.SetCurrentEvidenceCard,
      evidenceCard: evidenceCard
   }
};

FunctionList.setCurrentCardField = (field, value) => {
   return{
      type: Constants.SetCurrentCardField,
      field,
      value
   }
};

FunctionList.setRecentCards = (recentCards) => {
   return{
      type: Constants.SetRecentCards,
      recentCards
   }
};

FunctionList.setCardList = (cardList) => {
   return{
      type: Constants.SetCardList,
      cardList
   }
};

FunctionList.setCurrentVote = (value) =>{
   return{
      type:Constants.SetCurrentVote,
      value
   }
};

FunctionList.addCardToList = (card) =>{
   return{
      type: Constants.AddCardToList,
      card
   }
};

FunctionList.setUnapproved = (unapprovedList) => {
   return{
      type: Constants.SetUnapproved,
      unapprovedList
   }
};

FunctionList.addCardToUnapprovedList = (card) => {
   return{
      type: Constants.AddCardToUnapprovedList,
      card
   }
};

FunctionList.setRevisingCard = (revisingCard) => {
   return{
      type: Constants.SetRevisingCard,
      revisingCard
   }
};

exports.FunctionList = FunctionList;
